import { Crew, TicketDetail } from '@packages/database/types';

// Finds active crew given a ticket assignment
export const findActiveCrew = (
  ticketAssignments: TicketDetail['ticketAssignments'],
): Crew | null => {
  return ticketAssignments?.find((a) => a.isActive)?.crew ?? null;
};
